export class EnaioObjectIdAndType {
    //netgen start
    id = 0;
    typeId = 0;
    //netgen end

    constructor(id: number, typeId: number) {
        this.id = id;
        this.typeId = typeId;
    }


}
